/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VehicleBoxValidation } from '../../models/vehicle-box-validation';

export interface UpdateBoxValidation$Params {

/**
 * id of vehicle
 */
  vehicleId: number;

/**
 * id of the validation object
 */
  validationId: number;

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
      body: VehicleBoxValidation
}

export function updateBoxValidation(http: HttpClient, rootUrl: string, params: UpdateBoxValidation$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleBoxValidation>> {
  const rb = new RequestBuilder(rootUrl, updateBoxValidation.PATH, 'put');
  if (params) {
    rb.path('vehicleId', params.vehicleId, {});
    rb.path('validationId', params.validationId, {});
    rb.query('customerGUID', params.customerGUID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehicleBoxValidation>;
    })
  );
}

updateBoxValidation.PATH = '/vehicles/{vehicleId}/boxvalidations/{validationId}';
